import React from "react";

export default function Podcasts() {
  return (
    <section className="podcasts-page">
      <div className="podcasts-card">
        <div className="section-title-row">
          <h1 className="podcasts-title">Podcasts</h1>
        </div>

        <div className="podcasts-frame-wrap">
          <iframe
            src="https://a9.asurahosting.com/public/tapsi_web_radio/podcasts?embed=true&theme=dark"
            title="Tapsi Web Radio Podcasts"
            frameBorder="0"
            allowTransparency="true"
            className="podcasts-iframe"
          />
        </div>
      </div>
    </section>
  );
}
